import {
  Icon,
  Menu,
  MenuItem,
  MenuPopup,
  MenuTrigger,
  SidebarMenuAction,
  SidebarMenuButton,
  SidebarMenuItem,
  Text,
} from "@salestrak/ui";
import React, { useCallback } from "react";

import type { IssueRow } from "#app/lib/data";
import { copyText } from "#app/lib/utils/copy-actions";

export function FavoriteItem({
  issue,
  isActive,
  onClick,
  copyUrl,
  onRemove,
}: {
  issue: IssueRow;
  isActive: boolean;
  onClick: () => void;
  copyUrl: string;
  onRemove: (issueId: string) => void;
}) {
  const handleRemove = useCallback(() => {
    onRemove(issue.issueId);
  }, [onRemove, issue.issueId]);

  const handleCopyLink = useCallback(() => copyText(copyUrl, "Link"), [copyUrl]);

  return (
    <SidebarMenuItem>
      <SidebarMenuButton isActive={isActive} onClick={onClick}>
        <Icon name="star" />
        <Text truncate>{issue.name}</Text>
      </SidebarMenuButton>
      <Menu>
        <MenuTrigger
          render={<SidebarMenuAction aria-label="Favorite actions" showOnHover />}
        >
          <Icon color="muted" name="more-horizontal" size="sm" />
        </MenuTrigger>
        <MenuPopup align="start" side="right">
          <MenuItem onClick={handleCopyLink}>
            <Icon name="link" size="sm" />
            <Text>Copy link</Text>
          </MenuItem>
          <MenuItem onClick={handleRemove}>
            <Icon name="star" size="sm" />
            <Text>Remove from favorites</Text>
          </MenuItem>
        </MenuPopup>
      </Menu>
    </SidebarMenuItem>
  );
}
